function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import uuidv1 from 'uuid/v1';
import { WDHComponent } from '../../../../wdh-foundation/wdh';
import Location from './utils/model';
import defaultPropTypes from './utils/prop-types';
import LocationManager from './utils/LocationManager';
import { Filter } from './utils/LocationFilterManager';
import getQueryString from './utils/getQueryString';
import DefaultFormSettings from './default-form-settings.json';
var $ = jQuery; // eslint-disable-line
/**
 * @memberOf module:wdh-locations-spot
 */
var WDHLocationsSpot = /*#__PURE__*/function (_WDHComponent) {
  /**
   * @param {String} className - The unique css selector that triggers the component
   * @constructor
   * @augments WDHComponent
   * @inheritDoc
   */
  function WDHLocationsSpot() {
    var _this;
    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'locations-spot';
    _classCallCheck(this, WDHLocationsSpot);
    _this = _callSuper(this, WDHLocationsSpot, [className]);

    /**
     * Array of React.Elements for the desktop rendering.
     * @type {Array}
     */
    _this.desktopViews = [];

    /**
     * Array of React.Elements for the mobile rendering
     * @type {Array}
     * @private
     */
    _this.mobileViews = [];

    /**
     * Set a callback function to override the default logic for when to switch between
     * *mobile* and *desktop* views. Return true to go to *mobile*, return false to go to
     * *desktop*.
     * @type {function(int, int): boolean}
     */
    _this.resolveMobileBreakPoint = _this.defaultResolveMobileBreakPoint;

    /**
     * Set a callback function to calculate the height of the component
     * @type {function(): boolean|int}
     */
    _this.calculateHeight = _this.defaultCalculateHeight;
    _this.defaultSettings = {
      ApiKey: '',
      ClusterRadius: 0,
      Filters: [],
      IpLocation: new Location(),
      ListCount: 20,
      MapConfiguration: '{}',
      MaxZoomLevel: 15,
      MinLocationsOnLoad: 3,
      MinZoom: 3,
      Unit: 'KM',
      ZoomLevel: 7,
      Form: DefaultFormSettings
    };
    _this.defaultDictionary = {
      filterListButton: 'Filters',
      filterTitle: 'Filter locations',
      fromYourLocation: 'from your location',
      phone: 'Phone',
      website: 'Website',
      info: 'Info',
      getDirections: 'Get directions',
      searchFieldPlaceholder: 'What are you searching for?',
      outOf: 'Out of',
      next: 'Next',
      previous: 'Previous',
      showingResults: 'Showing results',
      email: 'E-mail',
      locationListButton: 'See location list',
      noDetailsAvailable: 'No details available for this location.',
      miles: 'Miles',
      kilometers: 'Kilometers',
      openingHours: 'Opening Hours',
      fromSearchedLocation: 'from',
      searchHeader: 'Find Hearing Center',
      searchMessageIfNoResults: 'No results found'
    };
    _this.autoHeightOnMobileDetailView = false;

    // updates SortLocation when a user uses the search bar on the map.
    _this.shouldReSortListOnSearch = false;
    _this.useClustering = true;
    return _this;
  }

  /**
   * The default logic for switching between *mobile* and *desktop*. Returns true when window.innerWidth is <= 768 pixels.
   * @param width
   * @returns {boolean}
   * @private
   */
  _inherits(WDHLocationsSpot, _WDHComponent);
  return _createClass(WDHLocationsSpot, [{
    key: "defaultResolveMobileBreakPoint",
    value: function defaultResolveMobileBreakPoint(width) {
      return width <= 768;
    }

    /**
     * Disables js calculating height for the component by returning false
     * @returns false
     * @private
     */
  }, {
    key: "defaultCalculateHeight",
    value: function defaultCalculateHeight() {
      return false;
    }
  }, {
    key: "init",
    value: function init(component) {
      var settings = Object.assign({}, this.defaultSettings, this.getSettingsFromComponent(component));
      settings.dictionary = this.getDictionaryFromComponent(component);
      var path = window.location.pathname;
      var subPathIndex = path.indexOf('/location/');
      var basename = path.substr(0, subPathIndex > -1 ? subPathIndex : path.length);
      ReactDOM.render(/*#__PURE__*/React.createElement(Router, {
        basename: basename
      }, /*#__PURE__*/React.createElement(AppWithRouter, {
        desktopViews: this.desktopViews,
        mobileViews: this.mobileViews,
        endpoint: $(component).data('configuration'),
        settings: settings,
        resolveMobileBreakPoint: this.resolveMobileBreakPoint,
        calculateHeight: this.calculateHeight,
        shouldReSortListOnMapChange: !!this.shouldReSortListOnMapChange,
        shouldReSortListOnSearch: !!this.shouldReSortListOnSearch,
        autoHeightOnMobileDetailView: !!this.autoHeightOnMobileDetailView,
        useClustering: this.useClustering
      })), component.querySelector('.component-content'));
    }

    /**
     * Get the rendered settings for the component instance given by *component*
     * @param component
     * @private
     */
  }, {
    key: "getSettingsFromComponent",
    value: function getSettingsFromComponent(component) {
      var settingsElement = component.querySelector('script[type="application/json"]');
      var settings = {};
      try {
        settings = JSON.parse(settingsElement.textContent);
      } catch (e) {
        settings.error = "".concat(e.name, " - ").concat(e.message);
      }
      settings.Filters = settings.Filters.map(function (filter) {
        return new Filter(filter.Property, filter.Value, filter.Operator, filter.Label, filter.PreSelected);
      });
      return settings;
    }
  }, {
    key: "getDictionaryFromComponent",
    value: function getDictionaryFromComponent(component) {
      var _this2 = this;
      var dictionary = {};
      var keys = Object.keys(this.defaultDictionary);
      keys.forEach(function (key) {
        var snakeCaseKey = key.replace(/[A-Z]/g, '-$&').toLowerCase();
        var element = component.querySelector(".dictionary-".concat(snakeCaseKey));
        dictionary[key] = element ? element.textContent : _this2.defaultDictionary[key];
      });
      return dictionary;
    }

    /**
     * Adds a view to the rendering when in *desktop* mode.
     * @param view
     */
  }, {
    key: "addDesktopView",
    value: function addDesktopView(view) {
      this.desktopViews.push(view);
    }

    /**
     * Adds a view to the rendering when in *mobile* mode.
     * @param view
     */
  }, {
    key: "addMobileView",
    value: function addMobileView(view) {
      this.mobileViews.push(view);
    }
  }]);
}(WDHComponent);
var DGS = window.DGS; // eslint-disable-line
var App = /*#__PURE__*/function (_React$Component) {
  function App(props) {
    var _this3;
    _classCallCheck(this, App);
    _this3 = _callSuper(this, App, [props]);
    _this3.state = {
      googleMapsApiLoaded: false,
      selectedLocation: new Location(),
      tempSelectedLocation: new Location(),
      openLocation: new Location(),
      locations: [],
      truncatedLocations: [],
      // used to limit pins on map
      width: window.innerWidth,
      height: window.innerHeight,
      searchLocation: Location.fromSettings(_this3.props.settings.IpLocation),
      userLocation: Location.fromSettings(_this3.props.settings.IpLocation),
      sortLocation: Location.fromSettings(_this3.props.settings.IpLocation),
      filters: Filter.fromSettings(_this3.props.settings.Filters),
      filterListOpen: false,
      locationDetailOpen: false,
      locationsStateHash: uuidv1(),
      title: document.title
    };

    /**
     * @type {Location[]}
     */
    _this3.rawLocations = [];

    /**
     * @type {LocationManager}
     */
    _this3.locationManager = new LocationManager();
    _this3.props.settings.Filters.forEach(function (filter) {
      if (filter.preSelected) _this3.locationManager.addFilter(filter);
    });
    _this3.updateDimensions = _this3.updateDimensions.bind(_this3);
    _this3.handleSelectLocationClick = _this3.handleSelectLocationClick.bind(_this3);
    _this3.handleTempSelectLocationClick = _this3.handleTempSelectLocationClick.bind(_this3);
    _this3.handleOpenLocationClick = _this3.handleOpenLocationClick.bind(_this3);
    _this3.handleCloseLocationClick = _this3.handleCloseLocationClick.bind(_this3);
    _this3.handleSearchLocationResult = _this3.handleSearchLocationResult.bind(_this3);
    _this3.handleChangeFilter = _this3.handleChangeFilter.bind(_this3);
    _this3.handleCloseFilterListClick = _this3.handleCloseFilterListClick.bind(_this3);
    _this3.handleOpenFilterListClick = _this3.handleOpenFilterListClick.bind(_this3);
    _this3.setTruncatedLocationState = _this3.setTruncatedLocationState.bind(_this3);
    _this3.handleMapChange = _this3.handleMapChange.bind(_this3);
    return _this3;
  }
  _inherits(App, _React$Component);
  return _createClass(App, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.getGoogleMaps();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;
      this.getGoogleMaps().then(function () {
        _this4.setState({
          googleMapsApiLoaded: true
        });
        _this4.updateUserLocation();
        _this4.getLocationsData();
      });
      window.addEventListener('resize', this.updateDimensions);
      window.onpopstate = function () {
        if (!Object.keys(_this4.props.match.params).length) {
          _this4.setState({
            locationDetailOpen: false
          });
        }
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // Update url if location has changed
      if (JSON.stringify(prevState.selectedLocation) !== JSON.stringify(this.state.selectedLocation)) {
        this.setParams(this.state.selectedLocation);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
    }
  }, {
    key: "getGoogleMaps",
    value: function getGoogleMaps() {
      var _this5 = this;
      // If we haven't already defined the promise, define it
      if (!this.googleMapsPromise) {
        this.googleMapsPromise = new Promise(function (resolve) {
          // Add a global handler for when the API finishes loading
          window.resolveGoogleMapsPromise = function () {
            // Resolve the promise
            // eslint-disable-next-line no-undef
            resolve(google);

            // Tidy up
            delete window.resolveGoogleMapsPromise;
          };

          // Load the Google Maps API
          var script = document.createElement('script');
          var API_KEY = _this5.props.settings.ApiKey;
          script.src = "https://maps.googleapis.com/maps/api/js?key=".concat(API_KEY, "&libraries=places&callback=resolveGoogleMapsPromise");
          script.async = true;
          document.body.appendChild(script);
        });
      }

      // Return a promise for the Google Maps API
      return this.googleMapsPromise;
    }

    /**
     * Updates the url with *map* and *place* query params
     * @param {Location} searchLocation
     */
  }, {
    key: "setParams",
    value: function setParams(searchLocation) {
      if (searchLocation.Latitude === 0 && searchLocation.Longitude === 0) {
        // useful when deselecting a map location with an empty object as lat:lng == 0:0
        window.history.replaceState({}, document.title, "".concat(window.location.href.split('?')[0]));
        return;
      }
      var mapQuery = "".concat(searchLocation.Latitude, ",").concat(searchLocation.Longitude);
      var placeQuery = searchLocation.Name;
      var newUrl = "".concat(window.location.href.split('?')[0], "?map=").concat(mapQuery, "&place=").concat(placeQuery);
      window.history.replaceState({}, document.title, newUrl);
    }

    /**
     * Get coordinate and search string from url search params
     * @param {window.location} location
     * @private
     */
  }, {
    key: "getParams",
    value: function getParams() {
      var mapString = getQueryString('map');
      var map = mapString && mapString.indexOf(',') > -1 ? mapString.split(',').map(parseFloat) : null;
      return {
        map: map,
        place: getQueryString('place') || ''
      };
    }

    /**
     * Load locations data from webservice
     * @private
     */
  }, {
    key: "getLocationsData",
    value: function getLocationsData() {
      var _this6 = this;
      var endPoint = "/webservices/locations.svc/getlocations/".concat(this.props.endpoint.substring(0, this.props.endpoint.length - 1).substr(1));
      $.get(endPoint, function (data) {
        if (data) {
          _this6.rawLocations = data.map(function (location) {
            return Location.fromWebserviceData(location);
          });
          // Check if there is a coordinate in url search params on first render
          var _this6$getParams = _this6.getParams(),
            map = _this6$getParams.map;
          if (map) {
            var searchLocation = Location.fromCoordinateArray(map);
            _this6.setState({
              searchLocation: searchLocation
            });
          }
          _this6.updateLocationsState();
        }
      });
    }

    /**
     * Sorts and filters a customized list of locations and sets the result in the state.
     * Used to display a limited amount of pins on the map
     *
     * @param locations
     */
  }, {
    key: "setTruncatedLocationState",
    value: function setTruncatedLocationState() {
      var locations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.setState({
        truncatedLocations: this.locationManager.sort(locations, this.state.sortLocation, this.state.userLocation)
      });
    }

    /**
     * Sorts and filter the raw locations and sets the result in the state.
     */
  }, {
    key: "updateLocationsState",
    value: function updateLocationsState() {
      var locations = this.locationManager.sort(this.rawLocations, this.state.sortLocation, this.state.userLocation);
      this.setState({
        locations: locations,
        locationsStateHash: uuidv1()
      });
    }

    /**
     * Attempt to request geolocation from browser
     * @private
     */
  }, {
    key: "updateUserLocation",
    value: function updateUserLocation() {
      var _this7 = this;
      var _navigator = navigator,
        geolocation = _navigator.geolocation;
      var location = new Promise(function (resolve, reject) {
        if (!geolocation) {
          reject(new Error('Not Supported'));
        }
        geolocation.getCurrentPosition(function (position) {
          resolve(position);
          window.DGS.Event.getInstance().trigger('trackLocationsUseLocation', true);
        }, function () {
          reject(new Error('Permission denied'));
          window.DGS.Event.getInstance().trigger('trackLocationsUseLocation', false);
        });
      });
      location.then(function (vals) {
        var userLocation = Location.fromGeolocation(vals.coords);
        if (JSON.stringify(_this7.state.searchLocation) === JSON.stringify(_this7.state.userLocation)) {
          _this7.setState({
            searchLocation: userLocation
          });
        }
        _this7.setState({
          userLocation: userLocation,
          sortLocation: userLocation
        });
      }, function () {}); // Fails silently on purpose, because the user either denied using geolocation or the feature is not supported in the browser
      return location;
    }

    /**
     * Updates the components state with information on the current window dimensions.
     * Triggers a re-render if the values have changed.
     */
  }, {
    key: "updateDimensions",
    value: function updateDimensions() {
      this.setState({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }

    /**
     * Sets the selectedLocation state to the given *locationId*.
     * @param locationId
     * @private
     */
  }, {
    key: "handleSelectLocationClick",
    value: function handleSelectLocationClick(location) {
      this.setState({
        selectedLocation: Location.fromObject(location)
      });
    }
  }, {
    key: "handleTempSelectLocationClick",
    value: function handleTempSelectLocationClick(location, state) {
      if (state === 'select') {
        if (!this.state.tempSelectedLocation || !this.state.tempSelectedLocation.equals(location)) {
          this.setState({
            tempSelectedLocation: Location.fromObject(location)
          });
        }
      } else if (this.state.tempSelectedLocation && this.state.tempSelectedLocation.equals(location)) {
        this.setState({
          tempSelectedLocation: new Location()
        });
      }
    }
  }, {
    key: "handleOpenLocationClick",
    value: function handleOpenLocationClick(location, e) {
      this.props.history.push("/location/".concat(location.UniqueId));
      this.setState({
        openLocation: location,
        locationDetailOpen: true
      });
      if (e) e.preventDefault();
    }
  }, {
    key: "handleCloseLocationClick",
    value: function handleCloseLocationClick(e) {
      this.props.history.push('/');
      this.setState({
        openLocation: new Location(),
        locationDetailOpen: false
      });
      if (e) e.preventDefault();
    }
  }, {
    key: "handleOpenFilterListClick",
    value: function handleOpenFilterListClick(e) {
      this.setState({
        filterListOpen: true
      });
      window.DGS.Event.getInstance().trigger('trackLocationsOpenFilterList');
      if (e) e.preventDefault();
    }
  }, {
    key: "handleCloseFilterListClick",
    value: function handleCloseFilterListClick(e) {
      this.setState({
        filterListOpen: false
      });
      if (e) e.preventDefault();
    }
  }, {
    key: "handleSearchLocationResult",
    value: function handleSearchLocationResult(searchLocation) {
      var _this8 = this;
      if (this.props.shouldReSortListOnSearch) {
        this.setState({
          searchLocation: searchLocation,
          userLocation: searchLocation,
          sortLocation: searchLocation
        }, function () {
          _this8.updateLocationsState();
        });
      } else {
        this.setState({
          searchLocation: searchLocation,
          userLocation: searchLocation
        }, function () {
          _this8.updateLocationsState();
        });
      }
      this.setParams(searchLocation);
    }
  }, {
    key: "handleChangeFilter",
    value: function handleChangeFilter(filter, e, resetFilters) {
      var _this9 = this;
      var filterState = this.state.filters;
      if (resetFilters === true) {
        this.locationManager.resetFilters();
        Object.keys(filterState).forEach(function (key) {
          filterState[key] = false;
        });
      }
      filterState[filter.id] = e.target.checked;
      if (e.target.checked) {
        this.locationManager.addFilter(filter);
        window.DGS.Event.getInstance().trigger('trackLocationsAddFilter', filter.label);
      } else {
        this.locationManager.removeFilter(filter);
        window.DGS.Event.getInstance().trigger('trackLocationsRemoveFilter', filter.label);
      }
      this.setState({
        filters: filterState
      }, function () {
        _this9.updateLocationsState();
      });
    }
  }, {
    key: "handleMapChange",
    value: function handleMapChange(_ref) {
      var _this0 = this;
      var center = _ref.center;
      if (this.props.shouldReSortListOnMapChange) {
        var sortLocation = new Location();
        sortLocation.Latitude = center.lat;
        sortLocation.Longitude = center.lng;
        this.setState({
          sortLocation: sortLocation
        }, function () {
          _this0.updateLocationsState();
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this1 = this;
      var isMobile = this.props.resolveMobileBreakPoint(this.state.width, this.state.height);
      var height = this.props.calculateHeight();
      var locationsContainerStyle = {};
      if (height !== false) {
        locationsContainerStyle.height = "".concat(parseInt(height, 10), "px");
      }
      var googleMapsApiLoaded = this.state.googleMapsApiLoaded;
      var views = isMobile ? this.props.mobileViews : this.props.desktopViews;
      var layoutType = isMobile ? 'mobile' : 'desktop';
      if (!googleMapsApiLoaded) {
        return /*#__PURE__*/React.createElement("div", null);
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "locations-container ".concat(layoutType, " ").concat(this.state.filterListOpen || this.state.locationDetailOpen ? 'popover-open' : '', " ").concat(this.state.filterListOpen ? 'filter-list-open' : '', " ").concat(this.state.locationDetailOpen ? 'location-detail-open' : ''),
        style: this.state.locationDetailOpen && this.props.autoHeightOnMobileDetailView && isMobile ? {} : locationsContainerStyle
      }, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, this.state.title)), views.map(function (view) {
        return /*#__PURE__*/React.cloneElement(view, {
          key: "_".concat(view.key),
          locations: _this1.state.locations,
          truncatedLocations: _this1.state.truncatedLocations,
          selectedLocation: _this1.state.selectedLocation,
          tempSelectedLocation: _this1.state.tempSelectedLocation,
          openLocation: _this1.state.openLocation,
          onSelectLocation: _this1.handleSelectLocationClick,
          onTempSelectLocation: _this1.handleTempSelectLocationClick,
          onOpenLocation: _this1.handleOpenLocationClick,
          onCloseLocation: _this1.handleCloseLocationClick,
          onSearchLocation: _this1.handleSearchLocationResult,
          onChangeFilter: _this1.handleChangeFilter,
          onCloseFilterList: _this1.handleCloseFilterListClick,
          onOpenFilterList: _this1.handleOpenFilterListClick,
          setTruncatedLocationState: _this1.setTruncatedLocationState,
          onClickCluster: _this1.handleClusterClick,
          filtersState: _this1.state.filters,
          settings: _this1.props.settings,
          layoutType: layoutType,
          searchLocation: _this1.state.searchLocation,
          userLocation: _this1.state.userLocation,
          sortLocation: _this1.state.sortLocation,
          filterListOpen: _this1.state.filterListOpen,
          locationDetailOpen: _this1.state.locationDetailOpen,
          locationsStateHash: _this1.state.locationsStateHash,
          defaultSearchValue: _this1.getParams().place,
          onMapChange: _this1.handleMapChange,
          useClustering: _this1.props.useClustering
        });
      }));
    }
  }]);
}(React.Component);
App.propTypes = {
  settings: defaultPropTypes.settings.isRequired,
  desktopViews: defaultPropTypes.components.isRequired,
  mobileViews: defaultPropTypes.components.isRequired,
  endpoint: PropTypes.string.isRequired,
  resolveMobileBreakPoint: defaultPropTypes.func.isRequired,
  calculateHeight: defaultPropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  shouldReSortListOnMapChange: PropTypes.bool.isRequired,
  shouldReSortListOnSearch: PropTypes.bool.isRequired,
  autoHeightOnMobileDetailView: PropTypes.bool.isRequired,
  useClustering: PropTypes.bool.isRequired
};
var AppWithRouter = withRouter(App);
export default WDHLocationsSpot;